(function() {

    'use strict';

    angular.module('Services').factory('ComplianceAttachmentTable', ComplianceAttachmentTable);
    ComplianceAttachmentTable.$inject = [
        '$location',
        'ComplianceService',
        'TableLiteFactory',
        'toastr',
        '$uibModal',
        '$rootScope',
        'ConfirmationModalFactory',
        '$filter'
    ];

    function ComplianceAttachmentTable(
        $location,
        ComplianceService,
        TableLiteFactory,
        toastr,
        $uibModal,
        $rootScope,
        ConfirmationModalFactory,
        $filter,
    ) {
        return function (compliance) {
            const deleteConf = new ConfirmationModalFactory({},{
                message: 'messages.warning.deleteRecord.MESSAGE',
                code: 'messages.warning.statusChange.CODE'
            });

            function openAttachmentUpload(attachment) {
                const modalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    controller: 'UploadAttachmentModalController',
                    templateUrl: '/templates/pages/compliance/modals/UploadAttachmentModal.html',
                    backdrop: 'static',
                    controllerAs: 'vm',
                    size: 'md',
                    appendTo: $('body'),
                    resolve: {
                        attachment: ()=>attachment,
                        complianceId: ()=>compliance.id
                    }
                });

                modalInstance.result.then(data => {
                    sendRequest({});
                });
            }

            const tableData = {
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Add new',
                        tooltip: 'Add new compliance rule',
                        onClick: function(){
                            openAttachmentUpload({});
                        }
                    }]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                    tableMinHeight: '10em'
                },
                headers: [{
                    label: 'Title',
                    viewName: 'title',
                    filterName: 'title',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }, {
                    label: 'File Name',
                    viewName: 'fileName',
                    filterName: 'fileName',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Status',
                    viewName: 'status',
                    filterName: 'active',
                    filter: {
                        type: 'select2',
                        placeholder: 'Select One',
                        items: ['Enabled', 'Disabled'],
                        onSelect: function(header) {
                            const filter = {};

                            filter[header.filterName] = header.filter.model === 'Enabled';

                            sendRequest(filter);
                        }
                    },
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Date Uploaded',
                    viewName: 'createdDate',
                    filterName: 'createdDate'
                }, {
                    label: 'Actions',
                    viewName: 'action',
                    class: 'text-center'
                }],
                rowOnClick: function (item) {
                    openAttachmentUpload(item);
                },
                data: []
            };

            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: ComplianceService.attachments.getAll,
                    callbackFormat: ['id','success','error','filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    paramId: compliance.id,
                    defaultFilters : {
                        size: 20,
                        page: 0,
                        sort: 'id,desc',
                        'complianceItem.Id': compliance.id
                    }
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                /*** START - Building of Data ***/

                tableActions.initializeTableData(data);
                if(!data)
                    return null;
                angular.forEach(data.content, function(row, index) {
                    row.createdDate = $filter('bbaDate')(compliance.createdDate);
                    row.status = row.active ? 'Enabled' : 'Disabled';
                    row.action = {
                        type: 'button',
                        buttons: [{
                            text: 'Delete',
                            class: 'btn btn-danger',
                            action: function () {
                                deleteConf.getInstance().result.then(cond => {
                                    if(cond) {
                                        ComplianceService.attachments.delete(data => {
                                            toastr.success('Item deleted', 'Success');
                                            sendRequest();
                                        }, error => {
                                            toastr.error('Unable to delete item', error.message);
                                        }, row.id);
                                    }
                                });
                            }
                        }]
                    };
                   
                    tableData.data.push(row);
                    
                });
                /*** END - Building of Data ***/
            }
            console.log(tableData);
            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/compliance/ComplianceAttachmentTable.js